"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NEW_TAB_REL = exports.MIN_SIZE = exports.MEDIA_ID_NO_FEATURED_IMAGE_SET = exports.LINK_DESTINATION_NONE = exports.LINK_DESTINATION_MEDIA = exports.LINK_DESTINATION_CUSTOM = exports.LINK_DESTINATION_ATTACHMENT = exports.ALLOWED_MEDIA_TYPES = void 0;
const MIN_SIZE = 20;
exports.MIN_SIZE = MIN_SIZE;
const LINK_DESTINATION_NONE = 'none';
exports.LINK_DESTINATION_NONE = LINK_DESTINATION_NONE;
const LINK_DESTINATION_MEDIA = 'media';
exports.LINK_DESTINATION_MEDIA = LINK_DESTINATION_MEDIA;
const LINK_DESTINATION_ATTACHMENT = 'attachment';
exports.LINK_DESTINATION_ATTACHMENT = LINK_DESTINATION_ATTACHMENT;
const LINK_DESTINATION_CUSTOM = 'custom';
exports.LINK_DESTINATION_CUSTOM = LINK_DESTINATION_CUSTOM;
const NEW_TAB_REL = ['noreferrer', 'noopener'];
exports.NEW_TAB_REL = NEW_TAB_REL;
const ALLOWED_MEDIA_TYPES = ['image'];
exports.ALLOWED_MEDIA_TYPES = ALLOWED_MEDIA_TYPES;
const MEDIA_ID_NO_FEATURED_IMAGE_SET = 0;
exports.MEDIA_ID_NO_FEATURED_IMAGE_SET = MEDIA_ID_NO_FEATURED_IMAGE_SET;
//# sourceMappingURL=constants.js.map